import { Dispatch, ThunkAction } from '../../../../../../types/actions';
import { segmentTrackAction, SegmentUserEvent } from '../../../../../../middlewares/segment';
import {
    SegmentUserOption,
    SegmentUserPlayerValue
} from '../../../../../../middlewares/segment/trackEntities/userEvents';
import { ETutorial } from '../../../../../../types/rest/IUserMeta';
import { TUTORIALS_NAME_MAP } from '../constants';

export const onPlay = (
    tutorial: ETutorial,
    isPlaying: boolean
): ThunkAction => {
    const action = (
        dispatch: Dispatch
    ) => {
        dispatch(segmentTrackAction(SegmentUserEvent.TUTORIAL_PLAY, {
            name: SegmentUserOption.TYPE,
            value: isPlaying ? SegmentUserPlayerValue.PLAYING : SegmentUserPlayerValue.PAUSED
        }, [
            { name: SegmentUserOption.STATUS, value: TUTORIALS_NAME_MAP[tutorial] }
        ]));
    }
    return action;
}
